import H2 from "components/atoms/H2"
import useTranslations from "hooks/useTranslations"

/**
 * Closing note. Wellbeing and account questions go to the school, because in
 * the UK the school's own safeguarding lead handles cases, never SomeBuddy
 * staff. Only platform questions come to us.
 */
export default function ParentInfoContact() {
  const {
    parentInfoContactTitle,
    parentInfoContactSchool,
    parentInfoContactSupportLabel,
    parentInfoContactSupportText,
    parentInfoContactEmail,
  } = useTranslations()

  return (
    <div className="bg-white py-16 lg:py-24">
      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <H2
          size="md"
          className="m-0 mb-6 text-left font-extrabold tracking-tight"
          theme="light"
        >
          {parentInfoContactTitle}
        </H2>
        <div className="space-y-4 text-base leading-snug text-zinc-800 lg:text-lg">
          <p className="m-0">{parentInfoContactSchool}</p>
          <p className="m-0">
            <strong>{parentInfoContactSupportLabel}</strong>{" "}
            {parentInfoContactSupportText}{" "}
            <a
              href={`mailto:${parentInfoContactEmail}`}
              className="font-bold text-kkm-darkgreen underline"
            >
              {parentInfoContactEmail}
            </a>
            .
          </p>
        </div>
      </section>
    </div>
  )
}
